function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Divider, HStack, Heading, Icon, IconButton, Modal, ModalBody, ModalContent, ModalOverlay, Text, VStack, useToken } from '@chakra-ui/react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { QRCodeSVG } from 'qrcode.react';
import CopyTextButton from '../CopyTextButton';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function TwoFactorSetupModal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onComplete = param.onComplete, twoFactorUrl = param.twoFactorUrl, twoFactorSecret = param.twoFactorSecret;
    var _useToken = _sliced_to_array(useToken('colors', [
        'backgroundPrimary',
        'backgroundInverse'
    ]), 2), backgroundColor = _useToken[0], foregroundColor = _useToken[1];
    var intl = useIntl();
    if (twoFactorUrl == null || twoFactorSecret == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsx(ModalContent, {
                bgColor: "backgroundPrimary",
                children: /*#__PURE__*/ _jsxs(ModalBody, {
                    padding: 0,
                    children: [
                        /*#__PURE__*/ _jsxs(HStack, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 6,
                            py: 4,
                            children: [
                                /*#__PURE__*/ _jsx(Heading, {
                                    size: "md",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "VXNjSd",
                                        defaultMessage: "Setup Authenticator"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(IconButton, {
                                    variant: "ghost",
                                    size: "sm",
                                    "aria-label": intl.formatMessage({
                                        id: "rbrahO",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Close"
                                            }
                                        ]
                                    }),
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: FontAwesomeIcon,
                                        icon: faClose
                                    }),
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            borderColor: "borderSecondary"
                        }),
                        /*#__PURE__*/ _jsxs(VStack, {
                            spacing: 4,
                            p: 6,
                            children: [
                                /*#__PURE__*/ _jsx(QRCodeSVG, {
                                    value: twoFactorUrl,
                                    size: 128,
                                    fgColor: foregroundColor,
                                    bgColor: backgroundColor
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "8pHTmu",
                                        defaultMessage: "Scan the QR code above with your authenticator app to enable two-factor authentication, or manually enter the following code:"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(CopyTextButton, {
                                    width: "100%",
                                    text: twoFactorSecret
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Divider, {
                            borderColor: "borderSecondary"
                        }),
                        /*#__PURE__*/ _jsxs(HStack, {
                            spacing: 6,
                            padding: 6,
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    flex: 1,
                                    onClick: onClose,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "rbrahO",
                                        defaultMessage: "Close"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    flex: 1,
                                    variant: "cta",
                                    onClick: function() {
                                        onClose();
                                        onComplete();
                                    },
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "q5Xl0M",
                                        defaultMessage: "Verify"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
